module.exports = __webpack_public_path__ + "static/rainbowspot3-3204cc075265f75d38c15d7dcf900190.png";